import { WorkerStoreSlice } from '../models';

export const selectConfig = (s: Pick<WorkerStoreSlice, 'config'>) => s.config;
